import { ClaimsDetailsDto } from "@/types";

type SubClaim = ClaimsDetailsDto["subClaims"][number];

/** The claim's only subclaim, or the single one the company is assigned to. Otherwise the user chooses. */
export const pickSubClaim = (subClaims: SubClaim[] = [], assignedRefs: string[] = []): string | null => {
    if (subClaims.length === 1) {
        return subClaims[0].gardSubClaimRef ?? null;
    }

    if (assignedRefs.length !== 1) {
        return null;
    }

    return subClaims.find(subClaim => subClaim.gardSubClaimRef === assignedRefs[0])?.gardSubClaimRef ?? null;
};
